<template>
  <v-card>
    <v-card-title class="d-flex justify-center">
      {{ mode }}
    </v-card-title>
    <v-form
      @submit.prevent="submitForm"
      :key="formReset"
      class="ml-5 mr-5"
      ref="form"
      v-model="valid"
    >
      <v-alert
        dense
        v-if="error"
        color="red"
        elevation="5"
        outlined
        text
        type="error"
        align="center"
        class="mr-1 ml-1 mb-5"
      >
        {{ alertValidate }}</v-alert
      >
      <DateWithCheck :showCheck="true" />
      <v-select
        class="mt-6"
        required
        dense
        :rules="rules"
        label="Empleado"
        outlined
        v-model="data.employees"
        :items="getEmployees"
        item-value="empId"
        item-text="employee"
        name="employees"
      />
      <v-select
        required
        dense
        :rules="rules"
        :label="$tc('changeSchedule.schedule')"
        outlined
        v-model="data.scheduleId"
        :items="getSchedules"
        item-value="id"
        item-text="name"
        @change="changeSchedule"
        name="scheduleId"
      />
      <v-select
        required
        dense
        :rules="rules"
        :label="$tc('changeSchedule.segment')"
        :disabled="disabledSegment"
        class="mr-1 ml-1"
        v-model="data.segmentId"
        :items="getSegment"
        item-value="segmId"
        name="segmentId"
        item-text="segment"
        @change="changeSegment"
        :no-data-text="$tc('changeSchedule.noSegment')"
      />
      <v-select
        class="mr-1 ml-1"
        required
        dense
        :rules="rules"
        :label="$tc('changeSchedule.initialDay')"
        :disabled="disabledDaySequence"
        v-model="data.initialDay"
        :items="initialDay"
        name="initialDay"
        :no-data-text="$tc('changeSchedule.noSequence')"
      />
      <v-select
        class="mr-1 ml-1"
        required
        dense
        :rules="rules"
        :label="$tc('changeSchedule.sequenceNumber')"
        :disabled="disabledDaySequence"
        :items="getSequence"
        item-value="id"
        item-text="id"
        name="sequenceNumber"
        :no-data-text="$tc('changeSchedule.noSequence')"
        v-model="data.sequenceNumber"
      />

      <div
        class="drop-zone mb-4"
        :class="{ 'drop-active': isDragging }"
        @dragover.prevent="isDragging = true"
        @dragleave="isDragging = false"
        @drop.prevent="handleDrop"
      >
        <v-file-input
          accept=".pdf,image/*"
          v-model="certificateFile"
          label="Documento adjunto"
          outlined
          dense
          append-icon="mdi-paperclip"
          :prepend-icon="null"
          hide-details
          class="mb-3"
        />

        <div class="text-caption text-center grey--text">
          Arrastrá el archivo acá o hacé click arriba
        </div>
      </div>

      <div class="d-flex justify-space-between pb-4">
        <v-btn class="bt-exit" @click="cancel">{{
          $tc("editRegistrations.cancel")
        }}</v-btn>
        <v-btn type="submit" class="bt-acept ml-3">
          {{ $tc("editRegistrations.acept") }}</v-btn
        >
      </div>
    </v-form>
  </v-card>
</template>
<script>
import DateWithCheck from "../../Complement/DateWithCheck.vue";
import employeesW from "../../../store/workflow/employeesW";
import schedules from "../../../store/workflow/schedule";
import date from "../../../store/common/date";
export default {
  components: { DateWithCheck },
  props: {
    formSubmitted: Boolean,
  },

  data() {
    return {
      mode: "Cambio de horario",
      inputsForm: [],
      valid: true,
      error: false,
      alertValidate: "",
      selects: [],
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      data: {
        scheduleId: null,
        segmentId: null,
        initialDay: null,
        sequenceNumber: null,
      },
      initialDay: null,
      disabledSegment: true,
      disabledDaySequence: true,
      formReset: false,
      certificateFile: null,
      isDragging: false,
    };
  },
  watch: {
    formSubmitted(newVal) {
      if (newVal) {
        this.cancel();
        this.formReset = true;
      }
    },
  },

  computed: {
    getEmployees() {
      const operId = localStorage.getItem("operId");
      return employeesW.state.employees.filter(
        (element) => element.operId == operId
      );
    },
    getSchedules() {
      return schedules.state.schedules;
    },
    getSegment() {
      return schedules.state.segments;
    },
    getSequence() {
      return schedules.state.sequence;
    },
  },
  methods: {
    handleDrop(e) {
      this.isDragging = false;
      const files = e.dataTransfer.files;
      if (files.length) {
        this.certificateFile = files[0];
      }
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    submitForm(e) {
      e.preventDefault();
      this.validation(e.target);
    },
    async handleSubmit(form) {
      const formData = new FormData(form);
      let itemsComplete = {};
      for (let [name, value] of formData) {
        itemsComplete[name] = value;
      }
      this.$refs.form.resetValidation();

      itemsComplete = {
        ...itemsComplete,
        from: date.state.dateFrom,
        to: date.state.dateTo,
        checkTo: date.state.checkTo,
      };

      if (this.certificateFile !== null) {
        itemsComplete["certificateFile"] = await this.toBase64(
          this.certificateFile
        );
      }

      this.$emit("save", itemsComplete);
    },
    cancel() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      this.$refs.form.resetValidation();
      this.data = {
        scheduleId: null,
        segmentId: null,
        initialDay: null,
        sequenceNumber: null,
      };
      this.certificateFile = null;
      this.disabledDaySequence = true;
      this.disabledSegment = true;
      this.$emit("cancel", this.data);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },
    validation(form) {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.handleSubmit(form);
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required dense");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    changeSchedule() {
      let message = this.$tc("workflow.notSegment");
      schedules.commit("setScheduleId", this.data.scheduleId);
      schedules.dispatch("getSegments").then(() => {
        if (schedules.state.segments.length == 0) {
          this.disabledSegment = true;
          this.showError(message);
        } else {
          this.hideError();
          this.disabledSegment = false;
        }
      });
    },
    showError(message) {
      this.error = true;
      this.alertValidate = message;
      setTimeout(() => {
        this.hideError();
      }, 10000);
    },
    hideError() {
      this.error = false;
      this.alertValidate = "";
    },
    changeSegment() {
      this.disabledDaySequence = false;
      schedules.commit("setScheduleId", this.data.scheduleId);
      schedules.commit("setSegmentId", this.data.segmentId);
      schedules.dispatch("getSequence");

      this.initialDay = this.inicialDay();
    },
    inicialDay() {
      let inicialDay = schedules.state.segments.filter((option) => {
        return option.segmId == this.data.segmentId;
      });
      let numberOfDays = inicialDay[0].days;

      let element = [];
      for (let array = 1; array <= numberOfDays; array++) {
        element.push(array);
      }
      return element;
    },
  },
};
</script>
<style scoped>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.drop-zone {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 16px;
  transition: 0.2s;
}

.drop-zone:hover {
  border-color: #1976d2;
}

.drop-active {
  border-color: #4caf50;
  background-color: #f1f8e9;
}
</style>
